module.exports = __webpack_public_path__ + "static/media/innovation_cup_23.28756fed.pdf";